import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { fetchQuery, graphql } from "react-relay"
import {
  capacityGaugeChartsQuery,
  capacityGaugeChartsQuery$data,
} from "@/modules/productivity-cockpit/components/__generated__/capacityGaugeChartsQuery.graphql"
import { GaugeChart } from "@/modules/productivity-cockpit/components/gauge-chart"
import { RelayEnvironment } from "@/relay-environment"

type TodayPerformanceIndicatorsOverview = capacityGaugeChartsQuery$data["todayPerformanceIndicatorsOverview"]

const todayPerformanceIndicatorsOverviewQuery = graphql`
  query capacityGaugeChartsQuery {
    todayPerformanceIndicatorsOverview {
      appointmentsLastHour {
        currentValue
        maxValue
      }
      appointmentsPerHour {
        currentValue
        maxValue
      }
      appointmentsThisHour {
        currentValue
        maxValue
      }
      totalAppointmentsToday {
        currentValue
        maxValue
      }
      totalAppointmentsClosedToday
    }
  }
`

export const ObcWzChart = () => {
  const { t } = useTranslation()

  const [todayPerformanceIndicatorsOverview, setTodayPerformanceIndicatorsOverview] =
    useState<TodayPerformanceIndicatorsOverview | null>(null)

  useEffect(() => {
    fetchQuery<capacityGaugeChartsQuery>(
      RelayEnvironment,
      todayPerformanceIndicatorsOverviewQuery,
      {},
      { fetchPolicy: "network-only" },
    ).subscribe({ next: (data) => setTodayPerformanceIndicatorsOverview(data.todayPerformanceIndicatorsOverview) })
  }, [])

  if (!todayPerformanceIndicatorsOverview) return null

  return (
    <>
      <GaugeChart
        data-testid="obc-wz-capacity"
        title={t("scheduling.productivityCockpit.appointmentsPerHour")}
        name="OBC_WZ"
        hideSubDivider
        value={todayPerformanceIndicatorsOverview.appointmentsPerHour.currentValue}
        maxValue={todayPerformanceIndicatorsOverview.appointmentsPerHour.maxValue}
      />
      <GaugeChart
        data-testid="obc-wz-capacity"
        title={t("scheduling.productivityCockpit.appointmentsThisHour")}
        name="OBC_WZ"
        hideSubDivider
        value={todayPerformanceIndicatorsOverview.appointmentsThisHour.currentValue}
        maxValue={todayPerformanceIndicatorsOverview.appointmentsThisHour.maxValue}
      />
      <GaugeChart
        data-testid="obc-wz-capacity"
        title={t("scheduling.productivityCockpit.appointmentsLastHour")}
        name="OBC_WZ"
        hideSubDivider
        value={todayPerformanceIndicatorsOverview.appointmentsLastHour.currentValue}
        maxValue={todayPerformanceIndicatorsOverview.appointmentsLastHour.maxValue}
      />
      <GaugeChart
        data-testid="obc-wz-capacity"
        title={t("scheduling.productivityCockpit.appointmentsToday")}
        name="OBC_WZ"
        hideSubDivider
        value={todayPerformanceIndicatorsOverview.totalAppointmentsToday.currentValue}
        maxValue={todayPerformanceIndicatorsOverview.totalAppointmentsToday.maxValue}
      />
      <div className="grid h-50 w-50">
        <div className="self-end justify-self-center pt-8 text-2xl font-medium">
          {todayPerformanceIndicatorsOverview.totalAppointmentsClosedToday}
        </div>
        <div className="text-on-surface self-end text-center text-sm leading-tight font-medium">
          {t("scheduling.productivityCockpit.totalAppointmentsClosedToday")}
        </div>
      </div>
    </>
  )
}
